module.exports = __webpack_public_path__ + "img/logo_portrait_color.bc396603.svg";